<template>
	<div class="container">
		<b
			><u> {{ item.text }} </u></b
		>
		<select @change="handleChange" v-bind="{ id: 'i' + item.id }" v-model="response.value">
			<option value="99">{{ selectMsg[lang] }}</option>
			<option v-for="lbl in item.label" :key="lbl.id" v-bind="{ value: lbl.id }">{{ lbl.text }}</option>
		</select>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	name: "special",
	props: {
		item: Object,
	},
	data() {
		return {
			response: {
				id: this.item.id,
				value: 99,
			},
		};
	},
	methods: {
		handleChange() {
			this.$emit("add:response", this.response);
		},
	},
	computed: mapGetters(["selectMsg", "lang"]),
};
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
}
.container > select {
	align-self: start;
	margin: 0.4rem 0 0.8rem 0;
}
</style>
